import axiosInstance from "../../../helpers/api";

export const getBookmarkedQuestions = (id) => {
  return axiosInstance.get(`/students/questions/book_marked`);
};

export const getMissedQuestions = (body) => {
  console.log(body);
  return axiosInstance.get(
    `/student/questions/missed_questions/${body?.type}`
  );
};

export const getQuestionBucketsForStudent = (course_id) => {
  const params = course_id ? { course_id } : {};
  return axiosInstance.get(`/student/question-buckets`, { params });
};
